import React, { Fragment } from 'react';
import Checkbox from '@common-components/form/Checkbox';

export const RenderCheckbox = ({ handleChange, handleBlur, values }) => {
    return(
        <Fragment>
            <div className='desktop:grid-col-fill tablet:grid-col-fill mobile-lg:grid-col-12 grid-col-12 attestation__panel' id='ede-attestation-panel'>
                <Checkbox
                    id ='attested'
                    isInputRequired = {true}
                    name = 'attested'
                    text ='selfDesignation.attestation.attest'
                    handleChange = {handleChange}
                    handleBlur = {handleBlur}
                    checked = {values.attested}
                    ariaHidden = { true }
                    showRequired = { true }
                />
            </div>
        </Fragment>
    );
};
